<script setup>
import { computed, inject } from 'vue'

// A single rail item: icon + label + collapsed hover-popout. Renders a
// <router-link> when `to` is set, otherwise a clickable div that emits `select`.
// Styling comes from ToolRail's global #tool-sidebar rules.

const props = defineProps({
  icon: {
    type: Array,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  active: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  // Router target. When set, the item is a link; when null it's a click button.
  to: {
    type: [String, Object],
    default: null
  }
})

const emit = defineEmits(['select'])

const railExpanded = inject('railExpanded', null)
const expanded = computed(() => (railExpanded ? railExpanded.value : false))

function onClick() {
  if (props.disabled) return
  emit('select')
}
</script>

<template>
  <li class="nav-item-wrapper">
    <!-- Link item -->
    <router-link
      v-if="to && !disabled"
      class="sidebar-nav"
      :class="{ active }"
      :to="to"
    >
      <font-awesome-icon class="icon" :icon="icon" />
      <span class="nav-text">{{ label }}</span>
      <div v-if="!expanded" class="nav-popout"><span>{{ label }}</span></div>
    </router-link>

    <!-- Button / disabled item -->
    <div
      v-else
      class="sidebar-nav"
      :class="{ active, disabled }"
      @click="onClick"
    >
      <font-awesome-icon class="icon" :icon="icon" />
      <span class="nav-text">{{ label }}</span>
      <div v-if="!expanded" class="nav-popout"><span>{{ label }}</span></div>
    </div>
  </li>
</template>
